// extracted by mini-css-extract-plugin
export default {"header":"mUrAmn","title":"ANER3M","description":"ZoK71E","hideSidebarButton":"oGOVdx","hideSidebarTooltip":"h83WFE","hideSidebarIcon":"gcv1Bx"};